// extracted by css-extract-rspack-plugin
export default {"root":"root-oGXq_I","text":"text-uuBwEA"};